import React from "react";
import { Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  EmojiObjects,
  TrendingUp,
  AccountBalance,
  LiveHelp,
  Speed,
  Lock,
  People,
  MonetizationOn,
  AccessTime,
  ThumbUp,
} from "@material-ui/icons";
import { useNavigate } from "react-router-dom";
import rocketImg from "../../../assets/img/rocket.png";
import brandTheme from "brandTheme/Theme";
import { Description, VerifiedUser, Business } from "@material-ui/icons";
import { getDeviceType } from "utils/Utils";
import { enableGetTheAppButton } from "assets/properties/properties";
const useStyles = makeStyles((theme) => ({
  "@keyframes fadeInUp": {
    "0%": {
      opacity: 0,
      transform: "translateY(30px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },

  "@keyframes softFloat": {
    "0%, 100%": {
      transform: "translateY(0)",
    },
    "50%": {
      transform: "translateY(-10px)",
    },
  },

  "@keyframes glow": {
    "0%, 100%": {
      boxShadow: `0 0px 20px ${brandTheme.mainColor}`,
    },
    "50%": {
      boxShadow: `0 0px 40px ${brandTheme.mainColor}`,
    },
  },

  container: {
    minHeight: "100vh",
    padding: theme.spacing(4),
    scrollBehavior: "smooth",
    position: "relative",
    overflow: "hidden",
    background: "linear-gradient(180deg, #FFFFFF 0%, #F5F8FF 100%)",
  },

  heroSection: {
    background:
      "linear-gradient(135deg, #1CB167 0%, #1CB167 50%, #020b5c 100%)",
    borderRadius: "28px",
    padding: "70px 60px",
    color: "#fff",
    marginBottom: "40px",
    display: "flex",
    alignItems: "center",
    gap: "50px",
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 20px 50px rgba(21, 37, 79, 0.28)",

    "&::before": {
      content: '""',
      position: "absolute",
      right: "-120px",
      top: "-100px",
      width: "500px",
      height: "500px",
      borderRadius: "50%",
      border: "1px solid rgba(21, 37, 79, 0.28)",
    },

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      textAlign: "center",
      padding: "50px 30px",
      gap: "32px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "36px 22px",
      borderRadius: "22px",
      marginBottom: "24px",
    },
  },

  heroIcon: {
    width: "140px",
    height: "140px",
    minWidth: "140px",
    borderRadius: "50%",
    border: `4px solid ${brandTheme.secondaryColor}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.05)",

    "& svg": {
      fontSize: "70px",
      color: "#fff",
    },

    [theme.breakpoints.down("sm")]: {
      width: "100px",
      height: "100px",
      minWidth: "100px",

      "& svg": {
        fontSize: "50px",
      },
    },
  },

  heroContent: {
    borderLeft: "2px solid rgba(255,255,255,0.25)",
    paddingLeft: "50px",

    [theme.breakpoints.down("md")]: {
      borderLeft: "none",
      paddingLeft: 0,
    },
  },

  heroTitle: {
    fontWeight: 800,
    marginBottom: "20px",
    fontSize: "56px",
    lineHeight: 1.2,

    [theme.breakpoints.down("md")]: {
      fontSize: "40px",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "30px",
      marginBottom: "14px",
    },
  },

  heroSubtitle: {
    maxWidth: "700px",
    lineHeight: 1.8,

    fontSize: "20px",
    fontWeight: 400,

    [theme.breakpoints.down("sm")]: {
      fontSize: "15px",
      lineHeight: 1.7,
    },
  },

  section: {
    marginBottom: theme.spacing(10),
  },

  sectionTitle: {
    textAlign: "center",
    color: brandTheme.mainColor,
    fontWeight: 800,
    marginBottom: theme.spacing(2),
    fontSize: "44px",

    [theme.breakpoints.down("md")]: {
      fontSize: "34px",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "26px",
    },
  },

  sectionSubtitle: {
    textAlign: "center",
    color: "#666",
    marginBottom: theme.spacing(8),
    fontSize: "18px",
    fontWeight: 500,
    letterSpacing: "0.2px",
    lineHeight: 1.6,
  },

  valuesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: theme.spacing(4),

    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: theme.spacing(3),
    },

    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      gap: theme.spacing(2),
    },
  },

  valueCard: {
    background: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(10px)",
    padding: theme.spacing(6),
    borderRadius: "28px",
    boxShadow:
      "0 15px 45px rgba(61,10,28,0.08), inset 0 1px 0 rgba(255,255,255,0.8)",
    transition: "all .5s cubic-bezier(.34,1.56,.64,1)",

    "&:hover": {
      transform: "translateY(-12px) scale(1.02)",
    },

    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(4),
    },

    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
      borderRadius: "18px",
    },
  },

  iconWrapper: {
    width: 85,
    height: 85,
    borderRadius: "50%",
    background: brandTheme.backgroundColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: brandTheme.secondaryColor,
    marginBottom: theme.spacing(3),

    "& svg": {
      fontSize: 40,
    },

    [theme.breakpoints.down("sm")]: {
      width: 64,
      height: 64,

      "& svg": {
        fontSize: 30,
      },
    },
  },

  cardTitle: {
    fontWeight: 700,
    color: brandTheme.mainColor,
    marginBottom: theme.spacing(2),
    fontSize: "22px",

    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },

  cardText: {
    color: "#555",
    lineHeight: 1.8,
    fontSize: "15px",

    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: 1.7,
    },
  },

  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(8),
  },

  statIconWrapper: {
    width: 96,
    height: 96,
    borderRadius: "50%",
    background: brandTheme.backgroundColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: brandTheme.secondaryColor,
    margin: "0 auto",
    marginBottom: theme.spacing(2),
    boxShadow: "0 8px 20px rgba(3, 29, 122, 0.08)",
    "& svg": {
      fontSize: 50,
    },
  },

  statCard: {
    background: "rgba(255, 255, 255, 0.85)",
    backdropFilter: "blur(10px)",
    padding: theme.spacing(5),
    borderRadius: "24px",
    textAlign: "center",
    boxShadow:
      "0 15px 45px rgba(3, 29, 122, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    transition: "all 0.4s ease",
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 20px 50px rgba(61, 10, 28, 0.12)",
    },
  },

  statNumber: {
    fontSize: "35px",
    fontWeight: 800,
    color: brandTheme.mainColor,
    margin: theme.spacing(1, 0),
    letterSpacing: "-1px",
  },

  statLabel: {
    color: "#555",
    fontSize: "14px",
    fontWeight: 600,
  },

  ctaSection: {
    background:
      "linear-gradient(135deg, #1CB167 0%, #1CB167 50%, #020b5c 100%)",
    borderRadius: "32px",
    padding: "40px",
    textAlign: "center",
    color: "#fff",
    boxShadow:
      "0 30px 100px rgba(61, 10, 28, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    animation: "$fadeInUp 1.2s ease-out both",
    marginBottom: theme.spacing(12),
  },

  ctaTitle: {
    fontWeight: 800,
    marginBottom: theme.spacing(2),
    fontSize: "40px",
    letterSpacing: "-0.5px",
    lineHeight: 1.2,
  },

  ctaText: {
    color: "#f0d9e6",
    marginBottom: theme.spacing(4),
    fontSize: "18px",
    fontWeight: 400,
    letterSpacing: "0.2px",
  },

  ctaButton: {
    margin: "auto",
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    color: brandTheme.white,
    padding: "22px 50px",
    borderRadius: "12px",
    fontWeight: 700,
    textTransform: "none",
    fontSize: "16px",
    boxShadow: "0 20px 40px rgba(255, 255, 255, 0.3)",
    transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
    letterSpacing: "0.5px",
    "&:hover": {
      backgroundColor:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
      transform: "translateY(-4px)",
      boxShadow: "0 30px 60px rgba(255, 255, 255, 0.4)",
    },
  },
  ctaImageWrapper: {
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    display: "flex",
    animation: "$softFloat 6s ease-in-out infinite",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      transform: "scale(2)",
    },
  },
  companySection: {
    background: "#F7F9FC",
    borderRadius: "28px",
    marginBottom: theme.spacing(10),
  },

  companyIntro: {
    textAlign: "center",
    maxWidth: "900px",
    margin: "0 auto 40px",
    color: "#666",
    lineHeight: 1.8,
    fontSize: "16px",
    padding: "0 16px",

    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginBottom: 24,
    },
  },

  companyGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: theme.spacing(3),

    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },

    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      gap: theme.spacing(2),
    },
  },

  companyCard: {
    background: "#fff",
    borderRadius: "18px",
    padding: theme.spacing(4),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
    boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
    transition: ".3s",

    "&:hover": {
      transform: "translateY(-5px)",
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      textAlign: "center",
      padding: theme.spacing(3),
      gap: theme.spacing(2),
    },
  },

  companyIcon: {
    width: 54,
    height: 54,
    borderRadius: "50%",
    background: "#F2F5FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,

    "& svg": {
      fontSize: 28,
      color: "#0A2E73",
    },

    [theme.breakpoints.down("sm")]: {
      width: 46,
      height: 46,

      "& svg": {
        fontSize: 24,
      },
    },
  },

  companyContent: {
    flex: 1,
  },

  companyLabel: {
    fontSize: 15,
    color: "#555",
    marginBottom: 6,
    fontWeight: 500,

    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
    },
  },

  companyValue: {
    fontSize: 17,
    fontWeight: 700,
    color: brandTheme.mainColor,
    lineHeight: 1.6,

    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
      lineHeight: 1.5,
      wordBreak: "break-word",
    },
  },
}));

export default function About() {
  const classes = useStyles();
  const navigate = useNavigate();
  const device = getDeviceType();
  const enableGetTheAppBtn = enableGetTheAppButton && device !=="ios"
  return (
    <div className={classes.container}>
      {/* Hero */}
      <div className={classes.heroSection}>
        <div className={classes.heroContent}>
          <Typography variant="h3" className={classes.heroTitle}>
            About GetCred
          </Typography>

          <Typography variant="body1" className={classes.heroSubtitle}>
            A modern digital lending platform dedicated to providing instant
            personal loans with seamless approvals, flexible EMI options and a
            completely digital customer experience.
          </Typography>
        </div>
      </div>

      {/* Stats */}
      <div className={classes.section}>
        <div className={classes.statsGrid}>
          <div className={classes.statCard}>
            <div className={classes.statIconWrapper}>
              <People />
            </div>
            <div className={classes.statNumber}>50K+</div>
            <div className={classes.statLabel}>Happy Customers</div>
          </div>
          <div className={classes.statCard}>
            <div className={classes.statIconWrapper}>
              <MonetizationOn />
            </div>
            <div className={classes.statNumber}>₹500Cr+</div>
            <div className={classes.statLabel}>Loans Disbursed</div>
          </div>
          <div className={classes.statCard}>
            <div className={classes.statIconWrapper}>
              <AccessTime />
            </div>
            <div className={classes.statNumber}>2 Min</div>
            <div className={classes.statLabel}>Avg Approval Time</div>
          </div>
          <div className={classes.statCard}>
            <div className={classes.statIconWrapper}>
              <ThumbUp />
            </div>
            <div className={classes.statNumber}>99.5%</div>
            <div className={classes.statLabel}>Customer Satisfaction</div>
          </div>
        </div>
      </div>

      {/* Core Values */}
      <div className={classes.section}>
        <Typography variant="h4" className={classes.sectionTitle}>
          Our Core Values
        </Typography>
        <Typography className={classes.sectionSubtitle}>
          Built on trust, innovation and customer success
        </Typography>

        <div className={classes.valuesGrid}>
          <div className={classes.valueCard}>
            <div className={classes.iconWrapper}>
              <EmojiObjects />
            </div>
            <Typography variant="h6" className={classes.cardTitle}>
              Innovation First
            </Typography>
            <Typography className={classes.cardText}>
              We leverage cutting-edge technology to simplify the loan journey
              with fast approvals and digital-first solutions.
            </Typography>
          </div>

          <div className={classes.valueCard}>
            <div className={classes.iconWrapper}>
              <TrendingUp />
            </div>
            <Typography variant="h6" className={classes.cardTitle}>
              Financial Empowerment
            </Typography>
            <Typography className={classes.cardText}>
              Our solutions help customers achieve their dreams with affordable
              and flexible loan options tailored to their needs.
            </Typography>
          </div>

          <div className={classes.valueCard}>
            <div className={classes.iconWrapper}>
              <AccountBalance />
            </div>
            <Typography variant="h6" className={classes.cardTitle}>
              Trust & Transparency
            </Typography>
            <Typography className={classes.cardText}>
              We believe in complete transparency with zero hidden charges and
              clear terms for every loan offered.
            </Typography>
          </div>

          <div className={classes.valueCard}>
            <div className={classes.iconWrapper}>
              <Speed />
            </div>
            <Typography variant="h6" className={classes.cardTitle}>
              Speed & Efficiency
            </Typography>
            <Typography className={classes.cardText}>
              Instant approvals and quick disbursals mean you get access to
              funds when you need them most.
            </Typography>
          </div>

          <div className={classes.valueCard}>
            <div className={classes.iconWrapper}>
              <Lock />
            </div>
            <Typography variant="h6" className={classes.cardTitle}>
              Security First
            </Typography>
            <Typography className={classes.cardText}>
              Your data is protected with enterprise-grade encryption and
              compliance with all regulatory standards.
            </Typography>
          </div>

          <div className={classes.valueCard}>
            <div className={classes.iconWrapper}>
              <LiveHelp />
            </div>
            <Typography variant="h6" className={classes.cardTitle}>
              Customer Support
            </Typography>
            <Typography className={classes.cardText}>
              Our dedicated team is available 24/7 to assist you at every step
              of your loan journey.
            </Typography>
          </div>
        </div>
      </div>
      {/* Company Information */}
      <div className={classes.companySection}>
        <Typography variant="h4" className={classes.sectionTitle}>
          Company Information
        </Typography>

        <Typography className={classes.companyIntro}>
          Aryaman Finance (India) Limited is a Non Banking Finance Company
          (NBFC) registered with the Reserve Bank of India (RBI). GetCred is the
          brand name under which the company conducts its lending operations and
          specialises in meeting customer’s instant financial needs.
        </Typography>

        <div className={classes.companyGrid}>
          <div className={classes.companyCard}>
            <div className={classes.companyIcon}>
              <Description />
            </div>

            <div className={classes.companyContent}>
              <Typography className={classes.companyLabel}>
                Corporate Identity Number (CIN)
              </Typography>

              <Typography className={classes.companyValue}>
                U64910MH2025PLC439433
              </Typography>
            </div>
          </div>

          <div className={classes.companyCard}>
            <div className={classes.companyIcon}>
              <VerifiedUser />
            </div>

            <div className={classes.companyContent}>
              <Typography className={classes.companyLabel}>
                RBI Certificate of Registration No. (CoR)
              </Typography>

              <Typography className={classes.companyValue}>13.02544</Typography>
            </div>
          </div>

          <div className={classes.companyCard}>
            <div className={classes.companyIcon}>
              <Business />
            </div>

            <div className={classes.companyContent}>
              <Typography className={classes.companyLabel}>
                Branch Office
              </Typography>

              <Typography className={classes.companyValue}>
                105, First Floor, Barodia Tower, D-Block, Central Market,
                Prashant Vihar, Rohini, Delhi-110085
              </Typography>
            </div>
          </div>
        </div>
      </div>
      {/* CTA */}
      <div className={classes.ctaSection}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <div className={classes.ctaImageWrapper}>
            <img src={rocketImg} alt="Rocket" />
          </div>
          <div>
            <Typography variant="h4" className={classes.ctaTitle}>
              Ready to Transform Your Financial Life?
            </Typography>

            <Typography className={classes.ctaText}>
              Join thousands of satisfied customers who have successfully
              received personal loans with Sathi.
            </Typography>
          </div>
          <Button
            className={classes.ctaButton}
            // onClick={() => navigate("/login")}
            onClick={() =>{
                if(enableGetTheAppBtn){
                window.open(
                  "https://play.google.com/store/apps/details?id=com.personalloanapp",
                  "_blank",
                  "noopener,noreferrer"
                )
              }else{
                navigate("/login")
              }
          }}
          >
            {enableGetTheAppBtn ? "Download App" : "Apply Now"}
          </Button>
        </div>
      </div>
    </div>
  );
}
